import { Component, OnInit } from '@angular/core';
import { Table } from 'primeng/table';
import { AlertMessage, AlertMessageService, AlertMessageType } from '@sigepe/sigepe-template';

export interface AlertMessageExtededService extends AlertMessageService {
    awatingMessage: {
        title: string;
        type: AlertMessageType;
    };
    setAwatingSuccessMessage(message: string);
    setAwatingInfoMessage(message: string);
    setAwatingWarnMessage(message: string);
    setAwatingErrorMessage(message: string);
    showAwaitingMessage(): void;
}

@Component({
    template: '',
    styles: []
})
export abstract class FeriasBaseComponent implements OnInit {
    constructor(private alertaMsgService: AlertMessageService) {}

    ngOnInit(): void {}

    getAlertaMsgService(): AlertMessageExtededService {
        this.extendAlertMessageService();
        return this.alertaMsgService as AlertMessageExtededService;
    }

    extendAlertMessageService() {
        (this.alertaMsgService as AlertMessageExtededService).showAwaitingMessage = () => {
            if ((this.alertaMsgService as AlertMessageExtededService).awatingMessage) {
                const message = (this.alertaMsgService as AlertMessageExtededService).awatingMessage;

                switch (message.type) {
                    case 'SUCCESS':
                        this.alertaMsgService.success(message.title);
                        break;

                    case 'INFO':
                        this.alertaMsgService.info(message.title);
                        break;

                    case 'WARN':
                        this.alertaMsgService.warn(message.title);
                        break;

                    case 'ERROR':
                        this.alertaMsgService.error(message.title);
                        break;
                }

                (this.alertaMsgService as AlertMessageExtededService).awatingMessage = undefined;
            }
        };

        (this.alertaMsgService as AlertMessageExtededService).setAwatingSuccessMessage = (message: string) => {
            if (message.trim()) {
                (this.alertaMsgService as AlertMessageExtededService).awatingMessage = {
                    title: message,
                    type: 'SUCCESS'
                };
            }
        };

        (this.alertaMsgService as AlertMessageExtededService).setAwatingInfoMessage = (message: string) => {
            if (message.trim()) {
                (this.alertaMsgService as AlertMessageExtededService).awatingMessage = {
                    title: message,
                    type: 'INFO'
                };
            }
        };

        (this.alertaMsgService as AlertMessageExtededService).setAwatingWarnMessage = (message: string) => {
            if (message.trim()) {
                (this.alertaMsgService as AlertMessageExtededService).awatingMessage = {
                    title: message,
                    type: 'WARN'
                };
            }
        };

        (this.alertaMsgService as AlertMessageExtededService).setAwatingErrorMessage = (message: string) => {
            if (message.trim()) {
                (this.alertaMsgService as AlertMessageExtededService).awatingMessage = {
                    title: message,
                    type: 'ERROR'
                };
            }
        };
    }

    clearMessages() {
        this.getAlertaMsgService().dismissAll();
    }

    pesquisar(msgCallback?: string): any {}

    alterarTituloTemplate(titulo: string) {
        if (titulo) {
            const sigepeHeader = document.getElementsByTagName('sigepe-header')[0];
            if (sigepeHeader) {
                const divHeaderList = sigepeHeader.getElementsByClassName('header-title');
                if (divHeaderList && divHeaderList.length > 0) {
                    divHeaderList[0].innerHTML = titulo;
                }
            }
        }
    }

    alterarTextoBreadcrumb(indice: number, texto: string) {
        if (texto) {
            setTimeout(() => {
                const sigepeBreadCrumbs = document.getElementsByTagName('sigepe-breadcrumbs')[0];
                if (sigepeBreadCrumbs) {
                    const breadcrumbList = sigepeBreadCrumbs.getElementsByTagName('li');
                    if (breadcrumbList && breadcrumbList.length > indice) {
                        const spanList = breadcrumbList[indice].getElementsByTagName('span');
                        if (spanList && spanList.length > 0) {
                            spanList[0].innerHTML = texto;
                        } else {
                            const linkList = breadcrumbList[indice].getElementsByTagName('a');
                            if (linkList && linkList.length > 0) {
                                linkList[0].innerHTML = texto;
                            }
                        }
                    }
                }
            }, 100);
        }
    }

    ajustarUsoTecladoGrid(table: Table) {
        if (table && table.el) {
            const foundTable = table.el.nativeElement.querySelector('table');
            if (foundTable) {
                const listaBotoesMenu: any[] = Array.from(foundTable.getElementsByClassName('p-column-filter-menu-button'));
                const listaBotoesClear: any[] = Array.from(foundTable.getElementsByClassName('p-column-filter-clear-button'));

                const listaBotoes = listaBotoesMenu && listaBotoesClear ? listaBotoesMenu.concat(listaBotoesClear) : listaBotoesMenu;

                listaBotoes.forEach(botao => {
                    botao.addEventListener('keyup', function (event) {
                        if ((event as any).key === 'Enter') {
                            event.preventDefault();
                            (botao as any).click();
                        }
                    });
                });

                if (listaBotoesClear) {
                    listaBotoesClear.forEach(botaoClear => {
                        botaoClear.addEventListener('keydown', function (event) {
                            event.stopPropagation();
                        });
                    });
                }
            }
        }
    }

    rolarParaTopo() {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }

    onTooltipTouchStart(event) {
        event.preventDefault();
        const mouseenterEvent = new Event('mouseenter', { cancelable: false });
        event.target.dispatchEvent(mouseenterEvent);
    }

    onTooltipTouchEnd(event) {
        event.preventDefault();
        const mouseleaveEvent = new Event('mouseleave', { cancelable: false });
        event.target.dispatchEvent(mouseleaveEvent);
    }
}
